import { useContext } from "react";
import { DashboardProspectsDIRContext } from "../../DashboardProspectsDIR.context";
import { useCommerciaux } from "../../../../../../../hooks/fetchers/useCommerciaux/useCommerciaux";
import { CommercialEnabledFilters } from "../../../DashboardCommerciaux/DashboardCommerciaux.types";
import Button from "../../../../../../designSystem/Button/Button";
import { useMutation, useQueryClient } from "react-query";
import { BaseResponse } from "../../../../../../../types/api/api.types";
import { AssignProspectQueryParams } from "./DashboardProspectsDIRAssignTable.types";
import { ASSIGN_PROSPECT_QUERY_KEY, assignProspectQuery } from "./DashboardProspectsDIRAssignTable.query";
import { useNavigate } from "react-router-dom";
import { useMergedStatesFromFetchers } from "../../../../../../../hooks/useMergedStatesFromFetchers/useMergedStatesFromFetchers";
import Loading from "../../../../../../commons/Loading/Loading";

export default () => {

  const navigate = useNavigate()

  const queryClient = useQueryClient()

  const { selectedProspect } = useContext(DashboardProspectsDIRContext)

  const {
    data: commerciaux,
    // refetch: refetchCommerciaux,
    isLoading: isCommerciauxLoading,
    // error,
  } = useCommerciaux({ 
    page: 1, 
    perPage: 1000, 
    enabled: CommercialEnabledFilters.Oui 
  });

  const { mutate: assignProspect, isLoading: isAssignProspectLoading } = useMutation<
    Awaited<BaseResponse>,
    Error,
    AssignProspectQueryParams
  >((data) => assignProspectQuery(data), {
    mutationKey: ASSIGN_PROSPECT_QUERY_KEY,
    onMutate: () => queryClient.cancelMutations(),
    onSuccess: () => {
      navigate(0)
    },
    onError: (error) => {
      console.log('error', error);
    },
  });

  const { isLoading } = useMergedStatesFromFetchers({ loadings: [isCommerciauxLoading, isAssignProspectLoading] })

  if (isLoading) return <Loading />

  return (
    <table className="dashboard__table" style={{ flex: 0, width: '100%' }}>
      <thead>
        <tr>
          <th>Commercial</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {commerciaux?.results.map(({ id, firstName, lastName }, index) => {
          return (
            <tr key={index}>
              <td>{firstName} {lastName}</td>
              <td
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end'
                }}
              >
                <Button
                  onClick={() => {
                    if (selectedProspect) {
                      assignProspect({
                        prospectId: selectedProspect.id,
                        commercialId: id
                      })
                    }
                  }}
                  disabled={id === selectedProspect?.id_commercial}
                >
                  Assigner
                </Button>
              </td>
            </tr>
          )
        })}
      </tbody>
    </table>
    )

}